import { ReactNode } from 'react';

export const ContainerNoTopSpace = ({ children }: { children?: ReactNode }) => <main className="px-4 md:px-8 lg:px-12 pb-8 flex-1"> {children} </main>;
